module.exports = __webpack_public_path__ + "static/img/third2_2_4_active.44c40c1c.jpg";